import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { useState } from 'react';
import { BondEntity, BondOptionsType } from '../../../../entities/bond.entity';
import { PRIMARY } from '../../../../shared/colors';
import { SearchContent } from '../SearchContent';
import { Courbes } from './components/Courbes';
import { Favoris } from './components/Favoris';
import { Movers } from './components/Movers';
import { Offres } from './components/Offres';
import { Portfolio } from './components/Porfolio';

const Container = styled.div`
  > .content {
    font-family: Poppins-R;
    border-radius: 5px;
    width: 100%;
  }
`;

export const Monitor = ({
  bonds,
  bondOptions,
  getBond,
}: {
  bonds: BondEntity[];
  bondOptions?: BondOptionsType;
  getBond: (b: BondEntity, ope: '1' | '2', detUrl?: string) => void;
}) => {
  const [tabIndex, setTabIndex] = useState('1');
  return (
    <Container>
      {/* <div className='top'>Monitor</div> */}

      <div className='content'>
        <Tabs
          defaultActiveKey='1'
          activeKey={tabIndex}
          type='line'
          onChange={(key: string) => setTabIndex(key)}
          size='small'
          tabBarStyle={{
            backgroundColor: PRIMARY,
            color: 'white',
            margin: '1px',
            borderRadius: 5,
          }}
        >
          <Tabs.TabPane
            tab={<span style={{ color: 'orange', marginLeft: 10 }}>SUIVI</span>}
            key='0'
            disabled
          >
            <p>SUIVI</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Titres' key='1'>
            <SearchContent
              mainScreen={true}
              bondsData={bonds}
              bondOptions={bondOptions}
              getBond={getBond}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Offres' key='2'>
            <Offres bondsData={bonds} getBond={getBond} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Portefeuille' key='3'>
            <Portfolio getBond={getBond} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Favoris' key='4'>
            <Favoris getBond={getBond} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Movers' key='5'>
            <Movers getBond={getBond} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Courbes des taux' key='6'>
            <Courbes bondsData={bonds} getBond={getBond} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Container>
  );
};
